import { render, staticRenderFns } from "./ContactOverviewHeader.vue?vue&type=template&id=3c966592&"
import script from "./ContactOverviewHeader.vue?vue&type=script&lang=js&"
export * from "./ContactOverviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContactOverviewHeader.vue?vue&type=style&index=0&id=3c966592&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports